export default [
  { label: 'Aviation', value: 'Aviation' },
  { label: 'Submarine', value: 'Submarine' },
  { label: 'Surface', value: 'Surface' },
  { label: 'Restricted Line', value: 'Restricted Line' }
]
